import { render, staticRenderFns } from "./DSearchInput.vue?vue&type=template&id=f6d96ffc"
import script from "./DSearchInput.vue?vue&type=script&lang=js"
export * from "./DSearchInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports